import { FunctionComponent } from 'react';
import { GetStaticPropsResult, NextPage } from 'next';

import { GrowthBookPageWrapper, GrowthBookPageWrapperProps, injectGrowthBookProps } from '../../utils/growth-book';
import { nextReduxWrapper } from '../../src/client/store/create-store';
import { STATIC_BUILD_REVALIDATE_TIME } from '../../src/client/ahm-constants/ui';
import constants from '../../src/client/ahm-constants';
import fetchProductsFromParams from '../../src/client/models/product/fetch-products-from-params';
import getProductIdsWithExcess from './get-product-ids-with-excess';
import logging from '../../src/client/logging';
import ProductListingPageNeeds from '../../src/client/pages/product-listing/needs';
import RedirectExistingMemberModal from '../../src/client/components/redirect-existing-member-modal';
import selectProducts from '../../src/client/selectors/select-products';
import useRedirectExistingMemberModal from './use-redirect-existing-member-modal';

const { ALL } = constants.CUSTOMER_NEEDS;

type ProductListingAllPageProps = GrowthBookPageWrapperProps & {
  match: {
    params: {
      needsProductType: typeof ALL;
      needsType: string;
    };
  };
  productIdsWithExcess: Record<string, number[]> | null;
};

export const createProductListingAllGetStaticProps = (needsType: string) =>
  nextReduxWrapper.getStaticProps((store) => async (): Promise<GetStaticPropsResult<ProductListingAllPageProps>> => {
    const params = { needsProductType: ALL, needsType };

    try {
      await fetchProductsFromParams(store.getState(), store.dispatch, params);

      const productIdsWithExcess = await getProductIdsWithExcess(selectProducts(store.getState()));

      const payload = await injectGrowthBookProps({
        context: { resolvedUrl: null },
        props: {
          match: { params },
          productIdsWithExcess,
        },
      });

      return {
        ...payload,
        revalidate: STATIC_BUILD_REVALIDATE_TIME,
      };
    } catch (error) {
      logging.getLogger().error('Product listing all page: SSG or ISR error', {
        error,
        needsType,
        params,
      });
      throw error;
    }
  });

const ProductListingAllPage: NextPage<ProductListingAllPageProps> = (props) => {
  const { isModalOpen, toggleModal } = useRedirectExistingMemberModal({ modalWaitSeconds: 45 });
  const PageComponent = ProductListingPageNeeds as FunctionComponent;

  return (
    <>
      <RedirectExistingMemberModal isOpen={isModalOpen} toggleModal={toggleModal} />
      {GrowthBookPageWrapper(props, PageComponent)}
    </>
  );
};

export default ProductListingAllPage;
